import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';

import { ROUTE_ANIMATIONS_ELEMENTS } from '../../../../core/core.module';
import { State } from '../../vista-usuario.state';

@Component({
  selector: 'rpe-vista-usuario-container',
  templateUrl: './vista-usuario-container.component.html',
  styleUrls: ['./vista-usuario-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VistaUsuarioContainerComponent implements OnInit {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;

  constructor(private store: Store<State>) {}

  ngOnInit(): void {
    /*this.store.dispatch(entityPersonasLoadRequest());

    // Usuario de IDP
    this.store.dispatch(entityUsersLoadRequest);

    // Documento
    this.store.dispatch(entityPaisesDocumentoLoadRequest());        
    this.store.dispatch(entityTiposDocumentoLoadRequest());
    
    // Domicilio
    this.store.dispatch(entityPaisesLoadRequest());
    this.store.dispatch(entityDepartamentosLoadRequest());
    this.store.dispatch(entityLocalidadesAllLoadRequest());*/
  }
}
